import { PbPatchReturnProcessConditionsReq } from '@itsrever/rever-api'
import { patchReturnConditions } from '@/api/settings-api'
import {
  useSettingsDraft,
  useSettingsMutation
} from '@/application/manage-settings'
import {
  changedNonReturnableLists,
  emptyNonReturnableLists,
  toNonReturnableLists,
  toNonReturnablePatchRequest
} from './non-returnable-lists'
import {
  returnConditionsKey,
  useStoredReturnConditions
} from './stored-return-conditions'

export function useNonReturnableLists() {
  const { ecommerceId, stored, loading, loadFailed, reload } =
    useStoredReturnConditions(toNonReturnableLists)
  const [lists, setLists] = useSettingsDraft(stored, emptyNonReturnableLists)
  const originalLists = stored ?? emptyNonReturnableLists

  const { save: saveLists, saving } = useSettingsMutation({
    mutationFn: (request: PbPatchReturnProcessConditionsReq) =>
      patchReturnConditions(request),
    invalidate: returnConditionsKey(ecommerceId),
    successKey: 'non_returnable.save_success',
    errorKey: 'non_returnable.save_error'
  })

  async function save() {
    if (!ecommerceId) return false
    if (changedNonReturnableLists(originalLists, lists).length === 0)
      return false
    return saveLists(
      toNonReturnablePatchRequest(ecommerceId, originalLists, lists)
    )
  }

  return {
    ecommerceId,
    lists,
    setLists,
    originalLists,
    loading,
    loadFailed,
    reload,
    saving,
    save
  }
}
